<template>
	<div class="qualityenterprise">
		<leftnav class="fl" ></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title">全部内资企业搜索</span>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">全部内资企业库</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div> 
				<div class="opport-screen-list1">  
							<dl class="opport-screen bdbe">
								<dt class="fl">省份地区</dt>
								<dd class="fl">
									<span :class="provinceid == 0?'current a-screen':'a-screen'"@click="provincechoose(0);userdata.provinceText='全国地区' ">全国地区<em class="num">({{countryNum}})</em></span>
									<span v-for="(item,index) in provincedata" :key='index'	@click="provincechoose(item.areaId,index);userdata.provinceText=item.name"	:class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.name}}<em class="num">({{item.num}})</em></span>
								</dd>
							</dl> 
						</div>
					</div>
			 
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; "> 
					<!-- <span class="orangefont" v-for="(name,ind) in searchTextArry"><i v-show="ind>0">、</i>{{name}}</span> -->
						<p class="fl">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【<span class="orangefont" >{{kwtextsearchtext}}</span>】相关结果</p>
						<!-- <div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'" 	@click="enlistExport()" v-if="userdata.groupType == 1" v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
							</div> -->
					</div> 
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>序号</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr> 
							<tr v-for="(list,index) in enterpristlist">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.notionlist" @click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" v-for="item in list.taglist" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td class="collectfont1"><span  @click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br/>目标企业</span></td>
							</tr>
						</table> 
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出列表弹框 -->
<!-- 		<div class="enlistexportPop" v-show="exportpop">
			<div class="enlistexportPop_box">
				<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
				<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
				<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b class="redfont">{{exportnum}}</b>次</p>
				<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
				<span class="closebtn" @click="exportpop=false"></span>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe> -->
	</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title: "全部内资企业",countryNum:0,//全国城市的企业总数量
				searchTextArry:[],//搜索词分解后的名词
				searchPlaceholder:'请输入企业名称',
				fenkd:{children:[]},
				curindex: 6,comajaxurl:"",
				enterinarr: [
					{curindex: 1,type: 9,name: "上市公司",tagnum:10010,}, 
					{curindex: 2,type: 1,name: "龙头企业",tagnum:10010,},
					{curindex: 3,type: 2,name: "创新企业",tagnum:3,}, 
					{curindex: 4,type: 3,name: "优质企业",tagnum:10009},  
					], 
				userdata: {},  
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "宁德新能源",  
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				provinceid: 0, 
				provincedata:[],  
				enterpristlist: [],  
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序    
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',notionstep:0,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [
					{name:'综合',type:0},{name:'拿地数量',type:5}, {name:'拿地面积',type:6}, 	{name:'拿地金额',type:7}, {name:'投资项目数量',type:8},{name:'投资项目金额',type:9},{name:'控制企业',type:10}, ],  
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},  
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			}); 
			this.userdata = this.getuseriformation();
		},
		mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
			// console.log('sercatype:', this.searchtype);
			var defaultlist={},_this = this;  
			if(this.$route.query.kw){
				document.title = this.kwtextsearchtext+'-内资企业库搜索';
				this.kwtextsearchtext=this.$route.query.kw?this.$route.query.kw:'';
				this.ajaxsearchcompany(); 
				
			}else{
				this.$message({
					type: 'error',
					message: '请输入关键词搜索',
				});  
			}
		
		},
		methods: {  
			//企业列表导出数据 
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				}
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.$api.cyl.enterprise.export()+ '&token=' + this.userdata.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					console.log('一分钟冷却计时')}, 60000)
			}, 
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.ajaxsearchcompany();
			},
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				if(this.searchtext.length>0){
				this.provinceid=0; 
				this.kwtextsearchtext=this.searchtext;
				this.ajaxsearchcompany(1);
				}else{
					this.$message({
						type: 'error',
						message: '请输入关键词搜索',
					});  
				}
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
			pageHandler: function(page) {   
				this.ajaxsearchcompany(page); 
			},
		 provincechoose(id){
			//省份城市选择
				 console.log('省份城市选择',id);
					this.provinceid=id;
					this.ajaxsearchcompany();
			}, 
			ajaxsearchcompany(pages) {
				this.bus.$emit('loading', true); 
				this.page=pages?pages:1; 
				var _this = this;  //kw page province
				// var ajaxurl = this.$api.cyl.search.enterprise() + '?kw='+this.kwtextsearchtext+'&province='+this.provinceid+'&page=' + this.page;
				// ajaxurl='http://192.168.1.86:2247/api/cyl/v1/search/enterprise?kw=宁德新能源&province=0&page=1';
				// console.log(ajaxurl)
				$.ajax({
					type:"POST",
					url:this.$api.cyl.search.enterprise(),
					data:{kw:this.kwtextsearchtext,province:this.provinceid,page:this.page},
					headers:{AuthToken:this.userdata.token },
					success:function(res){  
						 console.log('企业列表', res); 
							_this.provincedata=res.cityList;
						 if (res.success) {
								document.title = _this.kwtextsearchtext+'-内资企业库搜索';
						 	var dataenterlist= res.list; 
						 	for (var i = 0; i < res.list.length; i++) { 
						 		dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode,'notionsort');
						 		dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);  
						 	} 
						 	_this.totalPage = res.totalPage;
						 	_this.pageSize = res.pageSize;
						 	_this.total = res.totalRecord;
						 	_this.haspage = res.list.length == res.pageSize;  
									if(_this.provinceid == 0){
										_this.searchTextArry=res.data;
										_this.countryNum=res.totalRecord;
									}
						 	_this.enterpristlist=dataenterlist; 
						 	_this.bus.$emit('loading', false);
						 } else {
						 	
						 }
					} 
				})  
				// console.log(datas);  
			},
			//  
		}
	}
</script>

<style>
</style>
